export enum EInfoWidgetType {
  SIDEBAR = "SIDEBAR",
  BANNER = "BANNER",
  FOOTER = "FOOTER"
}

export interface IInfoWidget {
  id?: string;
  type: EInfoWidgetType;
  title?: string;
  content: string;
  isVisible: boolean;
  ordering: number;
}
export const typeOptions = [
  { value: EInfoWidgetType.SIDEBAR, label: 'Sidebar' },
  { value: EInfoWidgetType.BANNER, label: 'Banner' },
  { value: EInfoWidgetType.FOOTER, label: 'Footer' },
];
